(function () {
    "use strict";

    angular
        .module("app")
        .component("chooseCustomerContent", { // choose-customer-content
            templateUrl: "src/app/login/chooseCustomerContent.html",
            controller: controller,
            bindings: {
                onContinue: "&",
                onCancel: "&"
            }
        });

    function controller(session, toast) {
        const $ctrl = this;
        $ctrl.session = session;
        $ctrl.ui = {
            busy: false
		};

		const defaultCustomer = {
			company_name: 'Select Customer',
			customer_id: null
		};
		$ctrl.customers = angular.copy($ctrl.session.user.customers);
		$ctrl.customers.unshift(defaultCustomer);
        $ctrl.selectedCustomer = defaultCustomer;

        $ctrl.customerSelected = () => {
            $ctrl.ui.busy = true;
            session
                .setCustomer($ctrl.selectedCustomer)
                .then(() => {
                    $ctrl.onContinue();
                })
                .catch(toast.errorHandler)
                .finally(() => $ctrl.ui.busy = false);
        };

    }
    controller.$inject = ["sessionService", "stToastFactory"];

})()